import { visualDesignerObjectTypeOrNull } from '@wirechunk/lib/designer/object-type.ts';
import {
  freeSitePreviewCookieName,
  freeSitePreviewParamName,
  visualPreviewObjectTypeCookieName,
  visualPreviewObjectTypeParamName,
} from '@wirechunk/lib/mixer/visual-preview.ts';

// The URL search params on page load.
const searchParams = new URLSearchParams(window.location.search);

// The value of the preview object type parameter on page load.
export const visualPreviewObjectType = visualDesignerObjectTypeOrNull(
  searchParams.get(visualPreviewObjectTypeParamName),
);

// Whether the site is being previewed for free.
export const freeSitePreview = !!searchParams.get(freeSitePreviewParamName);

// All these parameters are important:
// 1. No Expires so that the cookie is a session cookie.
// 2. No Max-Age so that the cookie is a session cookie.
// 3. Path=/ so that the cookie is set for the whole site.
// 4. SameSite=None so that the cookie is sent to the server in the preview iframe.
// 5. Secure so that the cookie is only sent to the server in the preview iframe.
const sessionCookieBaseAttrs = '; Path=/; SameSite=None; Secure';

if (visualPreviewObjectType) {
  document.cookie = `${visualPreviewObjectTypeCookieName}=${visualPreviewObjectType}${sessionCookieBaseAttrs}`;
}
if (freeSitePreview) {
  // The value of this cookie just needs to be not empty.
  document.cookie = `${freeSitePreviewCookieName}=true${sessionCookieBaseAttrs}`;
}

// Clear out these two search params from the URL for two reasons:
// 1. So that users aren't confused by weird looking URLs.
// 2. So that users don't try to copy this URL to share with others (without an active subscription).
if (visualPreviewObjectType || freeSitePreview) {
  searchParams.delete(visualPreviewObjectTypeParamName);
  searchParams.delete(freeSitePreviewParamName);
  window.history.replaceState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
}
